export interface ConceptContext {
  titleKey: string;
  descKey: string;
  philosophyKey?: string;
  scenarioKey?: string;
  telemetry?: Record<string, string>;
}

export class TianshuEngine {
  // Mock knowledge graph for ConceptTooltips.
  // In a real scenario, this could lazy-load JSONs or query an IPC service.
  static getConcept(key: string): ConceptContext {
    switch(key) {
      case 'Workflow Matrices':
        return {
          titleKey: 'inspector.workflows_title',
          descKey: 'inspector.workflows_desc',
          philosophyKey: 'inspector.workflows_philosophy',
          scenarioKey: 'inspector.workflows_scenario',
          telemetry: { 'Available Matrices': '4', 'Auto-Routing': 'Enabled' }
        };
      case 'inspector.concept_base_kinetics':
        return {
          titleKey: 'inspector.spatial_temporal_kinetics',
          descKey: 'inspector.concept_base_kinetics',
          philosophyKey: 'inspector.concept_base_kinetics',
          telemetry: { 'Transform Engine': 'WASM Verlet', 'Active Anchors': '2', 'Vector Math': 'Float32' }
        };
      case 'inspector.concept_provenance_view':
        return {
          titleKey: 'inspector.provenance',
          descKey: 'inspector.concept_provenance_view',
          philosophyKey: 'inspector.concept_provenance_view',
          telemetry: { 'Latent Space': 'FP8 Quantized', 'VRAM Allocation': '4.2GB / 16GB', 'Inference Sync': 'Lock-Step' }
        };
      case 'inspector.concept_color_metaphysics':
        return {
          titleKey: 'inspector.ai_grading',
          descKey: 'inspector.concept_color_metaphysics',
          philosophyKey: 'inspector.concept_color_metaphysics',
          telemetry: { 'Latent Map': 'Rec.2020 Space', 'Tone Engine': 'Semantic Deduction' }
        };
      case 'inspector.concept_time_warp':
        return {
          titleKey: 'inspector.time_warp',
          descKey: 'inspector.concept_time_warp',
          philosophyKey: 'inspector.concept_time_warp',
          telemetry: { 'Flow Algorithm': 'RAFT-Stereo', 'Interpolation': 'Sub-pixel', 'Motion Vectors': 'Computed (16ms)' }
        };
      case 'inspector.concept_fairlight_eq':
        return {
          titleKey: 'inspector.audio_sculpting',
          descKey: 'inspector.concept_fairlight_eq',
          philosophyKey: 'inspector.concept_fairlight_eq',
          telemetry: { 'Audio Engine': 'Neural Spatial Field', 'Processing': 'Frequency Domain' }
        };
      case 'canvas.concept_fluid_impedance':
        return {
          titleKey: 'canvas_topology.lbl_fluid_impedance',
          descKey: 'canvas_topology.desc_fluid_impedance',
          philosophyKey: 'canvas_topology.phil_fluid_impedance',
          telemetry: { 'Flow Constraint': 'Dynamic (Verlet)', 'Energy Dissipation': '0.98', 'Collision Matrix': 'Active' }
        };
      case 'canvas.concept_field_strength':
        return {
          titleKey: 'canvas_topology.lbl_field_strength',
          descKey: 'canvas_topology.desc_field_strength',
          philosophyKey: 'canvas_topology.phil_field_strength',
          telemetry: { 'Vector Space': 'L2 Norm', 'Inertia Map': 'Quantum', 'Force Emitters': 'Active Nodes' }
        };
      case 'inspector.concept_brand_guidelines':
        return {
          titleKey: 'inspector.brand_identity',
          descKey: 'inspector.concept_brand_guidelines',
          philosophyKey: 'inspector.concept_brand_guidelines',
          telemetry: { 'Constraint Solver': 'Active', 'Color Shift Margin': '< 0.01 DeltaE' }
        };
      case 'inspector.concept_toon_shading':
        return {
          titleKey: 'inspector.line_art',
          descKey: 'inspector.concept_toon_shading',
          philosophyKey: 'inspector.concept_toon_shading',
          telemetry: { 'Edge Detection': 'Sobel Neural Net', 'Line Fidelity': 'High' }
        };
      case 'inspector.concept_cell_shading':
        return {
          titleKey: 'inspector.cell_shading',
          descKey: 'inspector.concept_cell_shading',
          philosophyKey: 'inspector.concept_cell_shading',
          telemetry: { 'Light Falloff': 'Step Function', 'Shadow Detail': 'Preserved' }
        };
      default:
        return {
          titleKey: key,
          descKey: `${key} Description`,
        };
    }
  }
}
